import {
  Box,
  color,
  spacing,
  StyleProps,
  useColorMode,
  useIsMobileView,
} from 'deepstash-ui';
import React from 'react';
import NextImage from 'src/components/image/NextImage';
import { createGradient } from 'utils/constants';

interface CollectionSplashscreenBackgroundProps {
  collectionId?: number;
}

const CollectionSplashscreenBackground: React.FC<
  CollectionSplashscreenBackgroundProps & StyleProps
> = ({ collectionId, ...props }) => {
  const { colorMode } = useColorMode();
  const isMobileView = useIsMobileView();

  if (!collectionId) return null;

  return (
    <Box
      position="absolute"
      width="100vw"
      aspectRatio={{ base: '9/16', md: '16/9' }}
      maxHeight="110vh"
      top={0}
      left={0}
      overflow="hidden"
      zIndex={-1}
      {...props}
    >
      <NextImage
        wrapperStyle={{ position: 'absolute', width: '100%', height: '100%' }}
        imageUrl={`https://static.deepstash.com/collection/${
          isMobileView ? '' : 'landscape/'
        }${collectionId}.svg`}
        priority
      />
      {colorMode === 'dark' && (
        <Box
          position="absolute"
          height={spacing.toRem(256)}
          width="100%"
          top={0}
          left={0}
          background={createGradient(color[colorMode].background, 90)}
        />
      )}
      <Box
        position="absolute"
        height="50%"
        width="100%"
        bottom={0}
        left={0}
        background={createGradient(color[colorMode].background, 270)}
      />
    </Box>
  );
};

export default CollectionSplashscreenBackground;
